import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { existCardSears, getMessengerServiceSears, setCodeError } from '../../store/actions';
import { getCodeError } from '../../store/selectors/paymentsSelectors';
import ModalCardOk from '../molecules/ModalCardOk'
import ModalCardLoader from '../molecules/ModalCardLoader';
import styled from 'styled-components';
import  SearsHome  from "../organisms/SearsHome";
import { ClaroTooltip } from "@claropay/shared";
import * as sdkclaro from '@claropay/claro-pay-sdk-v2';

const Container = styled.div`
  width: 100%;
  overflow: scroll;
  background: #fff;
`;

class SearsContainer extends Component {
    
    constructor(props) {
        super(props)
        this.state = {
            serviceDataGeneric: this.props.paymentsConfig.services[0].serviceData.generic,
            serviceDataInfo: this.props.paymentsConfig.services[0].serviceData.info,
            disableSeeMoreButton: false,
            valueInput: "",
            disableButton: true,
            openToolTip: false,
            validForm: true,
            openAlert: false,
            cardNumber: ""
        }
    }

    componentDidMount() { 
        sdkclaro.getInstance().switchGoBackButton(true)
    }

    componentDidUpdate(props, state){
        const {codeError, getMessengerServiceSears, searsMessages} = props;
        const {sdkVersion, paymentsConfig, isClaroPartner, history} = this.props
        const {openAlert, cardNumber, serviceDataInfo } = state;
        if(codeError && !openAlert){
            getMessengerServiceSears("Sears", codeError);
        }
        if(codeError && searsMessages && searsMessages[0].code === codeError && !openAlert){
            this.setState({openAlert: true})
        }
        if(props.existCardSearsValue !== this.props.existCardSearsValue){
            history.push({ 
                pathname: '/plans-card-sears',
                state: {
                    searsCardNumber: cardNumber, 
                    serviceDataInfo,
                    sdkVersion,
                    paymentsConfig,
                    isClaroPartner
                }
            })
        }
    }

    onclickCloseTooltip = () => {
        this.setState({addCloseEfect:true});
        setTimeout(function() {
            this.setState({openToolTip: false})
        }.bind(this), 900);
    }

    handleClickTooltip = () => {
        this.setState({openToolTip:true, addCloseEfect:false});
    }

    handleOnchangeInput = (e)=> {
        let reg = new RegExp("^[0-9]{12,13}$", 'i');
        let disableButton;
        let valid ;
        let {value} = e.target;
        let valueInputCardNumber = (value > 13)? value.substr(0, 13): value
        if (reg.test(valueInputCardNumber)) {
            disableButton = false;
            valid = true;
        } else {
            valid = false;
            disableButton = true;
        }

        this.setState({disableButton: disableButton, valueInput: valueInputCardNumber, validForm : valid });
    }

    handleClickButton = (cardNumber) => {
        let {paymentsConfig, existCardSears, setCodeError} = this.props
        let {serviceId} = paymentsConfig.services[0].serviceData.info
        setCodeError(undefined);
        this.setState({cardNumber})
        existCardSears(cardNumber, serviceId,)
    }

    onclickModal = () => {
        const {setCodeError} = this.props;
        setCodeError(undefined)
        this.setState({openAlert:false});
    }
  

    render() {
        let {serviceDataInfo, disableButton, valueInput } = this.state;
        const { searsMessages, isLoadingExistCardSears } = this.props;
        return (
            <>
            <Container>
                <SearsHome 
                    titleSears = {serviceDataInfo.titleSears}
                    subtitleSears = {serviceDataInfo.subtitleSears}
                    disableButton = {disableButton}
                    valueInput = {valueInput}
                    handleOnchangeInput = { this.handleOnchangeInput }
                    handleClickTooltip = {this.handleClickTooltip }
                    handleClickButton = { this.handleClickButton }
                    validForm = {this.state.validForm}
                    disclaimer={serviceDataInfo.disclaimer}
                />
            </Container>
            <ClaroTooltip 
                isOpen={this.state.openToolTip}
                addCloseEfect={this.state.addCloseEfect}
                onclickCloseTooltip = {this.onclickCloseTooltip}
                text="En el siguiente ejemplo encontrarás los datos necesarios para pagar tu servicio."
                srcImage= "/images/tarjetaSearsNum.svg"
                colorButton ='#797878' 
                fontSizeTitle= "12px"
                heightImg="60%"
                height="60%"
                colorTitle = "rgb(98, 98, 98)"
                fontSizeButton="22px!important"
                paddingTitle="10px 20px 0px 20px"
                marginButton="0px -12px 10px 10px"
                fadeInTime="1s"
                fadeIn
                cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
                widthImg="85%"
                textSubtitle = ""
                fontFamily="AMX-Regular"
                colorSubtitle= '#838383'
                fontWeightTitle= "bold!important"
                fontWeightSubtitle = "normal!important"
                fontSizeSubtitle = "12px"
            />

                <ModalCardOk
                    isOpen={this.state.openAlert}
                    srcImage={searsMessages ? searsMessages[0].data.icon: ""}
                    text= { searsMessages ?  searsMessages[0].data.subject: ""}
                    textdetail={searsMessages ?  searsMessages[0].data.message: ""}
                    buttontext={searsMessages ?  searsMessages[0].data.buttons[0]: ""}
                    onclickModal={this.onclickModal}
                    onClickImg={this.onclickModal}
                /> 
                {
                    <ModalCardLoader  
                        isOpen={isLoadingExistCardSears}
                    />
                }
            </>
        )
    }
}

function mapStateToProps(state) {
  return {
    isLoadingExistCardSears: state.payments.isLoadingExistCardSears,
    codeError: getCodeError(state),
    searsMessages: state.payments.searsMessages,
    existCardSearsValue: state.payments.existCardSears,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
        existCardSears,
        getMessengerServiceSears,
        setCodeError,
    },
    dispatch,
  );
}

SearsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearsContainer);

export default SearsContainer